import { Box, Tab, Tabs } from '@mui/material';
import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { Filters } from './components/Filters';
import { TABS } from './constants';
import { MaOpportunitiesProvider, useMaOpportunitiesContext } from './MaOpportunitiesContext';
import { useStyles } from './styles';

const MaPageInner = () => {
  const classes = useStyles();
  const { currentTab, setCurrentTab, setRegion } = useMaOpportunitiesContext();
  const location = useLocation();

  const onTabChange = useCallback(
    newValue => {
      setCurrentTab(newValue);
      // update URL hash
      window.location.replace(`${window.location.pathname}${window.location.search}#${newValue}`);
    },
    [setCurrentTab],
  );

  useEffect(() => {
    // restore tab from URL hash
    const tag = location.hash.replace('#', '');
    // find the tab with the matching tag
    const tab = TABS.find(tab => tab?.tag === tag);
    onTabChange(tab?.tag || TABS[0].tag);
  }, [location.hash, onTabChange]);

  // get region query param from the URL in a useEffect and set it in the context
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const region = params.get('region');

    if (region) {
      // set region in context
      setRegion(region);
      // clear region param from URL
      params.delete('region');
      const newSearch = params.toString();
      const newUrl = `${window.location.pathname}${newSearch ? `?${newSearch}` : ''}${location.hash}`;
      window.history.replaceState({}, '', newUrl);
    }
  }, [location.search, location.hash, setRegion]);

  // if no tab is selected, show nothing
  if (currentTab === null) return null;

  return (
    <Box className={classes.root}>
      <Box className={classes.content}>
        <Filters />
        <Box className={classes.contentWrapper}>
          <Tabs className={classes.tabs} value={currentTab} onChange={(_, tab) => onTabChange(tab)}>
            {TABS.map(tab => (
              <Tab className={classes.tab} key={tab.tag} label={tab.label} value={tab.tag} />
            ))}
          </Tabs>

          {TABS.map(tab => currentTab === tab.tag && <tab.component key={tab.tag} />)}
        </Box>
      </Box>
    </Box>
  );
};

export const MaOpportunitiesPage = () => (
  <MaOpportunitiesProvider>
    <MaPageInner />
  </MaOpportunitiesProvider>
);
